import { useCallback, useEffect, useRef, useState } from 'react';
import { Animated, Easing, Platform } from 'react-native';
export function useDimensionAnimation({ initialValue, easing, duration, delay, nativeDriver }) {
    const animation = useRef(new Animated.Value(0)).current;
    const [dimension, setDimension] = useState(initialValue);
    useEffect(() => {
        Animated.timing(animation, {
            duration: duration || 300,
            toValue: dimension,
            delay,
            easing: easing || Easing.inOut(Easing.linear),
            useNativeDriver: !!nativeDriver
        }).start();
    }, [dimension]);
    return [animation, setDimension];
}
export function useAnimation({ initialValue, easing, duration, delay, nativeDriver }) {
    const animation = useRef(new Animated.Value(initialValue)).current;
    const value_ref = useRef(initialValue);
    const set = useCallback((value) => {
        return new Promise((res) => {
            value_ref.current = value;
            Animated.timing(animation, {
                duration: duration || 300,
                toValue: value,
                delay,
                easing: easing || Easing.inOut(Easing.linear),
                useNativeDriver: typeof nativeDriver === 'boolean'
                    ? nativeDriver
                    : Platform.OS !== 'web'
            }).start(() => res(value));
        });
    }, []);
    return [animation, set, value_ref];
}
